import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=6558c2c2&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=6558c2c2&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/news.less?vue&type=style&index=1&id=6558c2c2&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6558c2c2",
  null
  
)

export default component.exports